import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { DocumentEntityService } from "../services/document-entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { AclService } from "../services/acl-service";
import { SearchService } from "../services/search-service";
import { EntityConfigService } from "../services/entity-config-service";

export function RLDocuments() {
	var directive: ng.IDirective = {
		restrict: "AE",
		template: require("/assets/app/templates/documents.html"),
		scope: {
			entityid: "@",
			locked: "=?",
			initialized: "=?",
			aclString: "@"
		},
		controller: RLDocumentsController,
		controllerAs: "docVM",
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLDocumentsController) => {

			scope.$watch("initialized", (newValue: boolean, oldValue: boolean) => {
				if (newValue != oldValue && !newValue) {
					controller.RefreshDocuments()
						.then(() => {
							scope["initialized"] = true;
						});
				}
				controller.initialized = newValue;
			}, true);

			scope.$watch("entityid", (newValue: string, oldValue: string) => {
				controller.entityID = newValue;
				controller.Init(newValue);
			}, true);

			scope.$watch("locked", (newValue: boolean, oldValue: boolean) => {
				controller.locked = newValue;
			}, true);

			scope.$watch("aclString", (newValue: string, oldValue: string) => {
				controller.aclString = newValue;
			}, true);
		}
	};
	return directive;
}

interface IRLDocumentsScope extends ng.IScope {
	entityID: string;
	locked: boolean;
	initialized: boolean;
	aclString: string;
}

export class RLDocumentsController {
	static $inject = ["$scope", "$rootScope", "$sce", "$q", "$window", "documentEntityService", "notifyService", "eventService", "entityService", "aclService", "searchService", "entityConfigService"];

	entityID: string;
	entityRecord: Models.IEntity;
	templateID: number;

	visibility: number;
	initialized: boolean;
	downloadAttachments: Models.ITransactionAttachment[];
	documentTemplates: Models.ICharacteristicTemplate[];
	editDocumentCharDataCollection: Models.ICharDataCollection;                // chardata for editing documents
	uploadedDocuments: Models.IEntityCharDataPair[];
	documentVersions: Models.IDocumentRevision[];
	previewable: { [key: string]: boolean };//holds preview ind for documents
	versionUrls: { [key: string]: string };
	firstDocumentCharMetaData: Models.ICharDataCollection;
	documents: Models.IRecordDocument[];
	attachmentUrls: { [key: number]: string };
	recordUrls: { [key: string]: string };
	documentUrls: { [key: number]: string };
	contactTitles: { [key: number]: string };
	docIDToRelRecID: { [key: number]: number };
	entityFileContactRels: { [key: number]: { [key2: number]: number } };
	selectedFileRelRecIDs: number[];
	documentModalOpen: boolean;
	documentViewSrc: string;
	documentModalTitle: string;
	documentFileName: string;
	uploadModalOpen: boolean;
	versionsModalOpen: boolean;
	assocUserModalOpen: boolean;
	assocUserMode: number;
	userCharTypeID: number;
	selectedUserRecTitles: Models.IKeyValuePair<number, string>[];
	showAssocUsersModalOpen: boolean;
	showAssocFileRecID: number;
	enableContactAssoc: boolean;
	sharedDocuments: Models.IEntityCharDataPair[];
	firstSharedDocumentCharMetaData: Models.ICharDataCollection;
	sharedFileRecIDToParentIDDict: { [key: number]: Models.IKeyValuePair<string, string> };

	editDocumentID: string;
	openGroups: number[];
	open: boolean;
	locked: boolean;
	canCreate: boolean;
	canEdit: boolean;
	canDelete: boolean;

	documentTemplateGroupId: number;
	trueValue: boolean = true;
	falseValue: boolean = false;

	createFolderMode: boolean;
	newFolderName: string;
	parentEntityID: string;
	folders: Models.IEntityCharDataPair[];

	entityHierarchy: Models.IEntityHierarchy;
	entityRoot: Models.IEntitySearchDoc;
	totalDescendants: number;
	parentOpen: boolean;
	refreshHierarchy: boolean;
	refreshHierarchyEntityID: string;
	documentModifyAccessEntityIDs: number[];
	entityContactRels: { [key: number]: Models.IEntitySearchDoc[] };
	selectedDocumentEntityRecIDs: number[];
	showFolderUploaModalOpen: boolean;
	pickedFiles: IFilestackPickFile[];
	documentFolderTemplates: Models.ICharacteristicTemplate[];
	documentFileTemplates: Models.ICharacteristicTemplate[];
	selectedFolderTemplateID: number;
	selectedDocumentFileTemplateID: number;

	showJobProgressStatus: boolean;
	jobId: string;
	jobTitle: string;
	progressStatus: string;
	resultMessage: string;
	aclString: string;
	customColumns: Models.ICustomUserColumns;
	availableColumns: Models.IListTableColumn[];		
	maxSize: number = 3 * 1024 * 1024 * 1024;
	parentTemplateID: number;
	parentCharTypeID: number;

	constructor(private $scope: IRLDocumentsScope,
		private $rootScope: ng.IRootScopeService,
		private $sce: ng.ISCEService,
		private $q: ng.IQService,
		private $window: ng.IWindowService,
		private documentEntityService: DocumentEntityService,
		private notifyService: NotifyService,
		private eventService: EventService,
		private entityService: EntityService,
		private aclService: AclService,
		private searchService: SearchService,
		private entityConfigService: EntityConfigService) {

		this.entityID = "";

		this.entityRecord = null;
		this.visibility = 1;
		this.initialized = false;
		this.documentTemplates = [];
		this.uploadedDocuments = [];
		this.documentVersions = [];
		this.versionUrls = {};
		this.downloadAttachments = [];
		this.editDocumentCharDataCollection = null;
		this.firstDocumentCharMetaData = null;
		this.attachmentUrls = {};
		this.documents = [];
		this.documentUrls = {};
		this.documentModalOpen = false;
		this.documentViewSrc = Consts.PreviewLoadingPage.HtmlFile;
		this.documentFileName = "...loading";
		this.documentModalTitle = "";
		this.editDocumentID = null;
		this.uploadModalOpen = false;
		this.versionsModalOpen = false;
		this.previewable = {};
		this.openGroups = [];
		this.open = true;
		this.locked = true;
		this.canCreate = false;
		this.canEdit = false;
		this.canDelete = false;

		this.contactTitles = {};
		this.docIDToRelRecID = {};
		this.entityFileContactRels = {};
		this.selectedFileRelRecIDs = [];
		this.assocUserModalOpen = false;
		this.assocUserMode = null;
		this.userCharTypeID = Consts.CharTypeIDs.user;
		this.selectedUserRecTitles = [];
		this.showAssocUsersModalOpen = false;
		this.showAssocFileRecID = null;
		this.enableContactAssoc = false;
		this.sharedDocuments = [];
		this.firstSharedDocumentCharMetaData = null;
		this.sharedFileRecIDToParentIDDict = {};

		this.createFolderMode = false;
		this.documentModifyAccessEntityIDs = [];
		this.entityContactRels = {};
		this.selectedDocumentEntityRecIDs = [];
		this.showFolderUploaModalOpen = false;
		this.selectedFolderTemplateID = null;
		this.selectedDocumentFileTemplateID = null;
		this.parentOpen = false;
		this.refreshHierarchy = false;

		$scope.$watch(() => this.documentModalOpen, (newValue: boolean, oldValue: boolean) => {
			if (!newValue && oldValue) {
				this.editDocumentCharDataCollection = null;
				this.documentModalTitle = "";
			}
		}, true);

		$scope.$watch(() => this.assocUserModalOpen, (newValue: boolean, oldValue: boolean) => {
			if (!newValue && oldValue) {
				this.selectedUserRecTitles = [];
			}
		});

		$scope.$watch(() => this.showAssocUsersModalOpen, (newValue: boolean, oldValue: boolean) => {
			if (!newValue && oldValue) {
				this.showAssocFileRecID = null;
			}
		});

        eventService.on(Consts.Events.DocumentGenerated, () => {
            if (Utils.IdBuilder.splitEntityID(this.entityID).charTypeID == Consts.CharTypeIDs.transaction) {
                return this.Init(this.entityID);
            }
        });

		$scope.$watch(() => this.pickedFiles,
			(newValue, oldValue) => {
				if (newValue != oldValue && newValue != null) {
					var originalPaths: string[] = [];
					var filePickerPaths: string[] = [];
					var allFilesSize: number = 0;
					_.forEach(this.pickedFiles, (pf) => {
						allFilesSize = allFilesSize + pf.size;
						originalPaths.push(pf.originalPath);
						filePickerPaths.push(pf.key);
					});
					
					if (this.maxSize > allFilesSize) {
						if (originalPaths.length > 0) {
							this.startFolderUpload(originalPaths, filePickerPaths);
						}
					}
					else {
						alert("You are trying to upload folder that exceeds the max size limit allowed.");
					}					
				}
			}, true);

		$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
			if (newValue != oldValue && (newValue == "Done")) {
				this.progressStatus = "";
				this.showJobProgressStatus = false;
				this.refreshHierarchy = false;
				this.selectedFolderTemplateID = null;
				this.selectedDocumentFileTemplateID = null;
				this.RefreshDocuments()
					.then(() => {
						this.refreshHierarchy = true;
					});
			}
		});		

		$scope.$watch(() => this.customColumns, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.SetupCustomColumns(newValue);
			}
		});
	}

	Init(entityID: string) {
		if (!_.isEmpty(entityID)) {
			this.enableContactAssoc = Utils.IdBuilder.splitEntityID(entityID).charTypeID != Consts.CharTypeIDs.user;

			this.notifyService.startProgress();
			this.GetEntityRecord(entityID)
				.then(() => {
					this.entityID = entityID;					
					this.RefreshDocuments();

				}).finally(() => {
					this.notifyService.endProgress();
				});

			this.aclService.loadActivityAcls()
				.then((acls) => {
					this.canCreate = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod14);
					this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod14.Details);
					this.canDelete = Utils.AclUtil.hasDeleteAccess(acls, Consts.Acl.Activities._Site.Mod14);
				});

			this.getCharacteristicList(Consts.CharTypeIDs.document);
		}
	}

	GetEntityRecord(entityID: string): ng.IPromise<any> {
		return this.entityService.getEntityRecord(entityID)
			.then((result) => {
				this.entityRecord = result;
				this.parentTemplateID = result.templateID;
				this.parentCharTypeID = result.charTypeID;
			});
	}

	RefreshDocuments(): ng.IPromise<any> {
		this.notifyService.startProgress();

		return this.entityService.getEntityDocuments(this.entityID) //MF
			.then((result) => {
				var charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;
				this.entityService.getAssociatedTemplatesForTemplate(charTypeID, this.entityRecord.templateID, Consts.CharTypeIDs.document) // MF
					.then((templates) => {
						this.documentTemplates = templates.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
						this.documentFolderTemplates = this.documentTemplates.filter(t => t.templateGroupID == Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID);
						this.documentFileTemplates = this.documentTemplates.filter(t => t.templateGroupID != Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID);
						if (this.documentFolderTemplates.length > 0) {
							this.selectedFolderTemplateID = this.documentFolderTemplates[0].templateID;
						}						
					});

				this.downloadAttachments = result.downloadAttachments;
				this.attachmentUrls = result.attachmentUrls;
				this.documents = result.recordDocuments;
				this.recordUrls = result.recordUrls;
				this.initialized = true;
				this.refreshHierarchy = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	private getCharacteristicList(charTypeID: number) {
		return this.entityConfigService.getCharacteristicList(charTypeID)
			.then((res) => {
				var columns = _.sortBy(res, (chr) => {
					return chr.label;
				}).map((chr): Models.IListTableColumn => {
					return {
						solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
						label: chr.label,
						characteristicID: chr.characteristicID,
						formatter: Utils.CharUtil.GetFormatter(chr.dataTypeID),
						dataTypeID: chr.dataTypeID,
						systemIndicatorID: chr.systemIndicator
					}
				});

				this.availableColumns = columns;
			});
	}

	ViewDocument(document: Models.IRecordDocument) {
		var documentKey = document.documentID + "-" + document.documentRevisionID;
		this.documentModalTitle = document.filename;
		this.documentFileName = document.filename;
		this.documentViewSrc = this.recordUrls[documentKey]; ////this.$sce.trustAsResourceUrl(this.documentUrls[documentKey]); 
		this.documentModalOpen = true;
		this.documentTemplateGroupId = Consts.TemplateGroupIDs.RightslineDocTemplateGroup;
	}

	ViewDocumentEntity(documentEntityID: string) {
		var documentEntityCharDataPair: Models.IEntityCharDataPair;
		var promises = [];
		var fileName: string = "";
		var title: string = "";

		promises.push(this.entityService.getEntity(documentEntityID)
			.then((result) => {
				documentEntityCharDataPair = result;
				title = documentEntityCharDataPair.record.title;
				var tagLabel = _.find(documentEntityCharDataPair.charDataCollection.templateMetaData.characteristicMetaDatas, (md) => { return md.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.file; }).tagLabel;
				fileName = documentEntityCharDataPair.charDataCollection.charDatas[tagLabel][0].value;
				this.documentTemplateGroupId = documentEntityCharDataPair.record.templateGroupID;
			}));

		promises.push(this.documentEntityService.getDocumentDownloadUrl(documentEntityID)
			.then((result) => {
				this.documentViewSrc = result.data;
			}));

		this.$q.all(promises)
			.then(() => {
				var titleIndex = title.lastIndexOf('/')
				if (titleIndex >= 0) {
					this.documentModalTitle = title.substring(titleIndex + 1);
				}
				else {
					this.documentModalTitle = title;
				}

				var index = fileName.lastIndexOf('/');
				if (index >= 0) {
					this.documentFileName = fileName.substring(index + 1);
				}
				else {
					this.documentFileName = fileName;
				}
				this.documentModalOpen = true;
			});
	}

	ViewDocumentRevision(document: Models.IEntityCharDataPair) {
		var documentKey = document.record.recordRevisionID;
		this.documentModalTitle = document.record.title;
		var tagLabel = _.find(document.charDataCollection.templateMetaData.characteristicMetaDatas, (md) => { return md.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.file; }).tagLabel;
		this.documentFileName = document.charDataCollection.charDatas[tagLabel][0].value;
		this.documentModalOpen = true;
		this.documentViewSrc = this.versionUrls[documentKey];
		this.documentTemplateGroupId = document.record.templateGroupID;
	}

	ViewAttachment(attachment: Models.ITransactionAttachment) {
		this.documentModalTitle = attachment.attachmentLabel;
		this.documentFileName = attachment.attachmentLabel;
		this.documentModalOpen = true;
		this.documentViewSrc = this.attachmentUrls[attachment.attachmentID]; //this.$sce.trustAsResourceUrl(this.attachmentUrls[attachment.attachmentID]);
	}

	OpenUploadModal(template: Models.ICharacteristicTemplate, parentEntityID: string) {
		this.editDocumentCharDataCollection = null;
		var divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
		var templateID = Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.document, template.templateID);
		this.parentEntityID = parentEntityID;

		this.entityService.getEmptyEntityCharData(templateID)
			.then((result) => {
				this.editDocumentCharDataCollection = result;
				if (template.templateGroupID == Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID) {
					this.createFolderMode = true;
				}
				else {
					this.createFolderMode = false;
				}
				this.uploadModalOpen = true;
				this.editDocumentID = null;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	UploadDocument(isValid: boolean) {
		if (isValid) {
			if (this.editDocumentID == null) {
				this.CreateDocumentEntity();
			} else {
				this.UpdateDocumentEntity(this.editDocumentID);
			}
		}
	}

	CreateDocumentEntity() {
		this.notifyService.startProgress();
		var contractID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
		var templateID = Utils.IdBuilder.buildTemplateID(this.editDocumentCharDataCollection.templateMetaData.divID, Consts.CharTypeIDs.document, this.editDocumentCharDataCollection.templateMetaData.templateID);
		var charDatas = this.editDocumentCharDataCollection.charDatas;

		this.refreshHierarchy = false;
		this.documentEntityService.createDocument(templateID, this.parentEntityID, charDatas)
			.then((result) => {
				if (result.success) {
					this.notifyService.notifySuccess("Document Created");
					this.RefreshDocuments()
						.then(() => {
							this.uploadModalOpen = false;
							this.notifyService.endProgress();
						});
				} else {
					this.notifyService.notifyError("Error creating Document");
				}
			})
			.finally(() => {
				this.parentOpen = false;
				this.refreshHierarchy = true;
				this.refreshHierarchyEntityID = this.entityID;
				this.uploadModalOpen = false;
				this.notifyService.endProgress();
			});
	}

	GetDocumentVersions(documentEntityID: string) {
		this.notifyService.startProgress();
		var docCreatedByList: number[] = [];

		this.documentEntityService.getDocumentVersions(documentEntityID)
			.then((result) => {
				this.documentVersions = result.documentRevisions;
				_.each(this.documentVersions, doc => {
					var tagLabel = _.find(doc.charDataCollection.templateMetaData.characteristicMetaDatas, (md) => { return md.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.file; }).tagLabel;
					var docFileName = doc.charDataCollection.charDatas[tagLabel][0].value;
					var isPreviewable = false;
					_.each(Consts.PreviewTypes.PreviewableExtensions, ext => {
						if (_.contains(docFileName, ext) && !_.contains(docFileName, ",")) {
							isPreviewable = true;
						}
						doc.isPreviewable = isPreviewable;
					});
					docCreatedByList.push(doc.record.lastUpdatedBy);
				});
				this.versionUrls = result.documentUrls;				
			}, () => {
				this.notifyService.notifyError("Error getting revisions");
			})
			.finally(() => {
				if (docCreatedByList.length > 0) {
					var request: Models.ISearchResultByRecordIDsRequest = {
						charTypeID: Consts.CharTypeIDs.user,
						recordIDs: docCreatedByList.join(",")
					}
					this.entityService.getRecordDocumentsForRecordIDs(request)
						.then((result) => {							
							_.forEach(result.documents, (recordDocument) => {
								this.contactTitles[recordDocument.recordID] = recordDocument.title;
							});
						})
						.finally(() => {
							this.versionsModalOpen = true;
							this.notifyService.endProgress();
						});
				}
				else {
					this.versionsModalOpen = true;
					this.notifyService.endProgress();
				}				
			});
	}

	EditDocument(documentEntity: Models.IEntityCharDataPair) {
		this.notifyService.startProgress();
		this.editDocumentID = documentEntity.record.id;
		this.editDocumentCharDataCollection = _.cloneDeep(documentEntity.charDataCollection);
		this.uploadModalOpen = true;
		this.notifyService.endProgress();
	}

	EditDocumentEntity(editDocumentEntityID: string) {
		this.notifyService.startProgress();
		this.editDocumentID = editDocumentEntityID;

		this.entityService.getEntity(this.editDocumentID)
			.then((result) => {
				this.editDocumentCharDataCollection = result.charDataCollection;
				this.uploadModalOpen = true;
				this.notifyService.endProgress();
			});
	}

	UpdateDocumentEntity(documentEntityID: string) {
		this.notifyService.startProgress();
		var charDatas = this.editDocumentCharDataCollection.charDatas;
		this.refreshHierarchy = false;
		this.documentEntityService.updateDocument(documentEntityID, charDatas)
			.then((result) => {
				if (result.success) {
					this.notifyService.notifySuccess("Document updated");
					this.RefreshDocuments()
						.then(() => {
							this.uploadModalOpen = false;
							this.notifyService.endProgress();
						});
				} else {
					this.notifyService.notifyError("Error updating document");
				}
			})
			.finally(() => {
				this.uploadModalOpen = false;
				this.refreshHierarchy = true;
				this.notifyService.endProgress();
			});
	}

	DeleteDocument(documentEntity: Models.IEntityCharDataPair) {
		if (this.$window.confirm("Are you sure?")) {
			this.notifyService.startProgress();
			this.documentEntityService.deleteDocument(documentEntity.record.id)
				.then(() => {
					this.notifyService.notifySuccess("Document deleted");
					this.RefreshDocuments()
						.then(() => {
							this.notifyService.endProgress();
						});
				}, () => {
					this.notifyService.notifyError("Error deleting document");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	DeleteDocumentEntity(deletDocumentEntityID: string) {
		if (this.$window.confirm("Are you sure?")) {
			this.notifyService.startProgress();
			this.refreshHierarchy = false;
			this.documentEntityService.deleteDocument(deletDocumentEntityID)
				.then(() => {
					this.notifyService.notifySuccess("Document deleted");
					this.RefreshDocuments()
						.then(() => {
							this.notifyService.endProgress();
						});
				}, () => {
					this.notifyService.notifyError("Error deleting document");
				})
				.finally(() => {
					this.refreshHierarchy = true;
					this.notifyService.endProgress();
				});
		}
	}

	DeleteDocumentFolder(deleteDocumentEntityID: string) {
		if (this.$window.confirm("Are you sure you want to Delete This Document Folder?")) {
			this.documentEntityService.deleteDocumentFolder(deleteDocumentEntityID)
				.then((result) => {
					this.refreshHierarchy = false;
					this.showJobProgressStatus = true;
					this.jobId = result.jobID;
					this.jobTitle = result.jobTitle
				});
		}
	}

	DeleteDocumentVersion(documentEntity: Models.IEntityCharDataPair) {
		if (this.$window.confirm("Are you sure?")) {
			this.notifyService.startProgress();
			this.documentEntityService.deleteDocumentVersion(documentEntity.record.id, documentEntity.record.recordRevisionID)
				.then(() => {
					this.notifyService.notifySuccess("Document deleted");
					var index = _.findIndex(this.documentVersions, dv => dv.charDataCollection.entityID == documentEntity.charDataCollection.entityID);
					this.documentVersions.splice(index, 1);
				}, () => {
					this.notifyService.notifyError("Error deleting document");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	CloseDocModal() {
		this.documentFileName = "...loading";
		this.documentModalTitle = "";
		this.documentViewSrc = Consts.PreviewLoadingPage.HtmlFile;
		this.documentModalOpen = false;
	}

	ToggleOpen() {
		this.open = !this.open;
	}

	GrantAccess($event: ng.IAngularEvent) {
		$event.preventDefault();
		this.assocUserMode = 1;
		this.assocUserModalOpen = true;
	}

	RemoveAccess($event: ng.IAngularEvent) {
		$event.preventDefault();
		this.assocUserMode = 0;
		this.assocUserModalOpen = true;
	}

	ModifyAccess() {
		this.notifyService.startProgress();
		var promise: ng.IPromise<Models.IJobResponse> = null;

		var contactRecIDs = this.selectedUserRecTitles.map(kvp => kvp.key);

		if (this.assocUserMode == 0) {
			promise = this.documentEntityService.revokeContactAccess(this.selectedDocumentEntityRecIDs, contactRecIDs);
		} else {
			promise = this.documentEntityService.grantContactAccess(this.selectedDocumentEntityRecIDs, contactRecIDs);
		}
		promise
			.then((result) => {
				_.forEach(this.selectedDocumentEntityRecIDs, (recID) => {
					this.entityContactRels[recID] = [];
				});
				this.refreshHierarchy = false;
				this.showJobProgressStatus = true;
				this.jobId = result.jobID;
				this.jobTitle = result.jobTitle
			}, this.notifyService.errorResponseHandler)
			.then(() => {
				this.selectedUserRecTitles = [];
				this.selectedDocumentEntityRecIDs = [];
				this.assocUserModalOpen = false;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	ShowAssocUsers(documentEntityID: string) {
		this.showAssocFileRecID = Utils.IdBuilder.splitEntityID(documentEntityID).recID;
		if (_.isEmpty(this.entityContactRels[this.showAssocFileRecID])) {
			this.notifyService.startProgress();
			this.documentEntityService.getAssociatedUsers(documentEntityID)
				.then((result) => {
					this.showAssocUsersModalOpen = true;
					this.entityContactRels[this.showAssocFileRecID] = result.data;
					this.notifyService.endProgress();
				});
		}
		else {
			this.showAssocUsersModalOpen = true;
		}
	}

	RemoveContactAssoc($event: ng.IAngularEvent, contactRecID: number) {
		this.notifyService.startProgress();

		this.documentEntityService.revokeContactAccess([this.showAssocFileRecID], [contactRecID])
			.then((result) => {
				if (this.entityContactRels[this.showAssocFileRecID].length == 1) {
					this.entityContactRels[this.showAssocFileRecID] = [];
					this.showAssocUsersModalOpen = false;
				}
				else {
					var existingContactRels = this.entityContactRels[this.showAssocFileRecID];
					_.remove(existingContactRels, e => e.recordID == contactRecID);
				}
				this.refreshHierarchy = false;
				this.jobId = result.jobID;
				this.jobTitle = result.jobTitle
				this.notifyService.endProgress();
				this.showJobProgressStatus = true;
			});
	}

	OpenFolder(documentFolderID: number) {
		alert(documentFolderID);
	}

	ShowFolderUpload(selectedFolderTemplateID: number, parentEntityID: string) {
		this.showFolderUploaModalOpen = true;
		this.selectedFolderTemplateID = selectedFolderTemplateID;
		this.parentEntityID = parentEntityID;
	}

	startFolderUpload(originalPaths: string[], filePickerPaths: string[]) {
		this.documentEntityService.UploadFolder(this.parentEntityID, this.selectedFolderTemplateID, this.selectedDocumentFileTemplateID, originalPaths, filePickerPaths)
			.then((result) => {
				this.showFolderUploaModalOpen = false;
				this.showJobProgressStatus = true;
				this.jobId = result.jobID;
				this.jobTitle = result.jobTitle
			});
	}
		
	SetupCustomColumns(customColumns: Models.ICustomUserColumns) {
		customColumns.columns.forEach((col) => {
			var columnLabel: string;
			if (col.solrLabel.indexOf('_date') > -1 || col.solrLabel.indexOf('_updated') > -1 || col.solrLabel == 'created') {
				col.formatter = 'dateLocal:"L"';
			}

			var characteristic = _.find(this.availableColumns, (aCol) => {
				return aCol.characteristicID === col.characteristicID;
			});

			if (characteristic) {
				switch (characteristic.solrLabel) {
					case "title":
						columnLabel = 'Name';
						break;
					case "template":
						columnLabel = 'Template';
						break;
					case "status":
						columnLabel = 'Status';
						break;
					default:
						columnLabel = characteristic.label;
				}
				col.label = columnLabel;
			}
			else {
				if (col.solrLabel.indexOf('_') > -1) {
					var split = col.solrLabel.split('_');
					col.label = '';
					split.forEach((val) => {
						col.label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1) + ' ';
					});
				} else if (col.solrLabel == 'userlabel') {
					col.label = 'Contact';
				} else if (col.solrLabel == 'companylabel') {
					col.label = 'Company';
				} else if (col.solrLabel == 'created') {
					col.label = 'Created';
				}		
			}
		});

		var sortedColumns = _.sortBy(customColumns.columns, (col) => { return col.sequenceNumber; });
		customColumns.columns = sortedColumns;
		this.customColumns = customColumns;
	}
}